import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { parseAlertSearch } from './-alert-search';

export interface AdminHealthSearch {
  /** The admin alert feed row a Telegram link points at (#1352). */
  alert?: number;
}

export const Route = createFileRoute('/admin/health')({
  component: lazyRouteComponent(() => import('./-health.lazy'), 'default'),
  validateSearch: (search: Record<string, unknown>): AdminHealthSearch => {
    const alert = parseAlertSearch(search.alert);
    return alert === undefined ? {} : { alert };
  },
});
